import { useEffect, useState } from "react";
import { useMeQuery } from "../modules/auth/api/authApi";

/**
 * Silently keeps the authenticated user in sync with the database.
 * - Fetches /auth/me on every page load (mount)
 * - Re-fetches when the browser tab regains focus
 * - Re-fetches when the network reconnects
 * The result is written to localStorage by onQueryStarted in authApi,
 * which then fires "auth:updated" so AuthContext re-hydrates.
 */
export default function AuthSync() {
  const [hasToken, setHasToken] = useState(
    () => !!localStorage.getItem("token")
  );

  useEffect(() => {
    const sync = () => setHasToken(!!localStorage.getItem("token"));
    window.addEventListener("auth:updated", sync);
    return () => window.removeEventListener("auth:updated", sync);
  }, []);

  useMeQuery(undefined, {
    skip: !hasToken,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    refetchOnMountOrArgChange: true,
  });

  return null;
}
